import {Component, OnInit} from '@angular/core';
import {ObjectBaseModeComponent} from '../../../../../../core/shared/object/mvs-object-base/object-base-mode.component';

@Component({
    selector: 'bm-bank-transaction-family-base',
    template: '',
    standalone: false
})
export class BmBankTransactionFamilyBaseComponent extends ObjectBaseModeComponent implements OnInit {

    navigationItems = [
        {
            label: 'Transaktionsfamilie',
            action: 'bankTransactionFamily',
            tooltip: 'Banktransaktionsfamilie Details',
            icon: 'fa-solid fa-building-columns',
            toggleable: false,
            default: true
        },
        {
            label: 'Transaktionssubfamilien',
            action: 'bankTransactionSubFamily',
            tooltip: 'Banktransaktionssubfamilien',
            icon: 'fa-solid fa-diagram-project',
            toggleable: false,
            default: false
        }
    ];

    ngOnInit() {
        super.ngOnInit();
        this.initialized = true;
    }

}
